import React from 'react';
import './LayerCoberturaADTComponent.css';

const LayerCoberturaADTComponent = (props) => {

    const setColor = (x) => {
        return {
            backgroundColor: x,
        };
    };

    return (
        <>
            <div className="geotarget-cards">
                {
                    props.features.map((item, keyname) => (
                        <div className="geotarget-card" key={keyname}>
                            <div className="side" style={setColor(item.properties.cs_color)} />
                            <div className="content">
                                <div><span>Estado: </span><p>{item.properties.estado}</p></div>
                                <div><span>Municipio: </span><p>{item.properties.municipio}</p></div>
                                <div><span>Asentamiento: </span><p>{item.properties.tipo_colonia}</p></div>
                                <div><span>Nombre: </span><p>{item.properties.colonia}</p></div>
                                <div><span>CP: </span><p>{item.properties.cp}</p></div>
                                <div><span>Cobertura ADT: </span><p>{item.properties.cobertura}</p></div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    );
}

export default LayerCoberturaADTComponent;